import { render, staticRenderFns } from "./leftList.vue?vue&type=template&id=5040350b&"
import script from "./leftList.vue?vue&type=script&lang=js&"
export * from "./leftList.vue?vue&type=script&lang=js&"
import style0 from "./leftList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports